export const userRole = { admin: 'Admin', manager: 'Manager',dev: 'Developer', qa :"QA" }

export const userRoleArray = Object.keys(userRole).map(value => ({
  value,
  label: userRole[value]
}))